import { __decorate } from "tslib";
// Core
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { required, maxLength } from 'vuelidate/lib/validators';
// Extends
import CategoryTreeMixin from '@/helpers/vue_mixins/v3/CategoryTreeMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import { validationMixin } from 'vuelidate';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
// Children
import ActionButton from '@/components/action_button/Index.vue';
import BaseTextArea from '@/components/v2/BaseTextArea';
import CategoryPicker from '@/components/v3/CategoryPicker.vue';
// Models / Helpers
import { CategoryTree } from '@/helpers/constants/CategoryTree';
// Queries / Mutations
import AppUpdatePromptContext from '@/plugins/graphql/mutations/v3/prompts/app-update-prompt-context.gql';
let MerchantCategoryAndDescription = class MerchantCategoryAndDescription extends Mixins(CategoryTreeMixin, FormValidationsMixin, validationMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.categoryOptions = CategoryTree;
        this.form = {
            categoryTree: {},
            businessDescription: null,
        };
        this.requestOnFlight = false;
    }
    onSubmit() {
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }
        this.requestOnFlight = true;
        return this.$apollo
            .mutate({
            mutation: AppUpdatePromptContext,
            variables: {
                input: {
                    appUuid: this.$store.state.appUUID,
                    primaryCategories: Object.keys(this.form.categoryTree).filter((key) => this.form.categoryTree[key].primaryOption),
                    secondaryCategories: Object.keys(this.form.categoryTree)
                        .map((key) => this.form.categoryTree[key].secondaryOptions)
                        .flat(),
                    businessDescription: this.form.businessDescription,
                },
            },
        })
            .then(() => {
            this.requestOnFlight = false;
            this.$emit('onUpdate');
        });
    }
    mounted() {
        if (!this.prefill) {
            return;
        }
        if (this.prefill.categoryTree) {
            this.form.categoryTree = this.buildCategoryTree(this.prefill.categoryTree);
        }
        else {
            this.form.categoryTree = this.baseCategories();
        }
        this.form.businessDescription = this.prefill.businessDescription;
    }
};
__decorate([
    Prop({ type: Object, default: null })
], MerchantCategoryAndDescription.prototype, "prefill", void 0);
MerchantCategoryAndDescription = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextArea,
            CategoryPicker,
        },
        validations: {
            form: {
                categoryTree: {
                    required() {
                        const { categoryTree } = this.form;
                        const keys = Object.keys(categoryTree);
                        return keys.filter((key) => categoryTree[key].primaryOption === true).length > 0;
                    },
                },
                businessDescription: {
                    required,
                    maxLength: maxLength(800),
                },
            },
        },
    })
], MerchantCategoryAndDescription);
export default MerchantCategoryAndDescription;
